import { FC } from 'react';
import { ISwitchProps } from './types';
import styles from './switch.module.scss';

/**
 * Switch component that toggles a boolean state.
 *
 * @param {boolean} isActive - Current state of the switch.
 * @param {function} onChange - Function to call when the switch is toggled.
 * @param {boolean} [disabled=false] - Whether the switch is disabled.
 * @param {string} [classNameProp=''] - Additional class names for styling.
 */
export const Switch: FC<ISwitchProps> = ({ isActive, onChange, disabled, classNameProp }) => {
  return (
    <button
      type='button'
      className={`${styles.switchBtn} ${isActive && styles.active} ${classNameProp || ''}`}
      onClick={() => onChange(!isActive)}
      disabled={disabled}
    />
  );
};
